/**
 * Decode speech on both current Promise-based WebAudio implementations and
 * older Android/WebView implementations that only complete through callbacks.
 * WAV and MP3 support is supplied by the browser codec; this adapter prevents
 * API-version differences from turning a successfully fetched clip silent.
 */
export function decodeSpeechAudio(ctx, encodedBytes) {
  if (!ctx?.decodeAudioData || !(encodedBytes instanceof ArrayBuffer)) {
    return Promise.reject(new TypeError("Speech decoding requires an AudioContext and ArrayBuffer."));
  }

  return new Promise((resolve, reject) => {
    let settled = false;
    const resolveOnce = (buffer) => {
      if (settled) return;
      settled = true;
      if (buffer) resolve(buffer);
      else reject(new Error("Speech decoder returned no audio buffer."));
    };
    const rejectOnce = (error) => {
      if (settled) return;
      settled = true;
      reject(error instanceof Error ? error : new Error(String(error || "Speech decode failed.")));
    };

    try {
      const result = ctx.decodeAudioData(encodedBytes.slice(0), resolveOnce, rejectOnce);
      if (result && typeof result.then === "function") {
        result.then(resolveOnce, rejectOnce);
      }
    } catch (error) {
      rejectOnce(error);
    }
  });
}
